module.exports = __webpack_public_path__ + "img/woman.0cbdd004.png";